import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from 'vuex-along'
Vue.use(Vuex)

const state = {
    environment: 'inBrowser',
    cellphone: '',
    activityResp: {},
    fillinfo: {},
    lesson:{},
    profile:{},
}

import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const store = new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    plugins:[vuexAlong],
});



// WEBPACK FOOTER //
// ./src/store/index.js